import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import axios from "axios";
import { i18n } from '../../translate/i18n';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
  Paper, Typography, FormControl, IconButton, Container, TextField, Button, useMediaQuery, Tooltip, Chip, Box, FormHelperText
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachIcon from '@mui/icons-material/AttachFile';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import API from '../../axios/api';
import * as actions from "../../store/actions";

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle, FormStatus, FormStatusLabel, FormStatusValue, ExpandPainelContainer, ExpandPainelItemContainer, ExpandPainelItemLabel, ExpandPainelButton, ButtonGroup
} from './styles';

import confirm from '../../UI/Confirm/confirm';
import Autocomplete from '../../UI/Autocomplete/Autocomplete';
import Spinner from '../../components/Spinner/index';
import Upload from '../../UI/Upload';
import FileList from '../../UI/FileList';
import statusLabel from '../../utils/statusLabel';
import TimelineActions from './TimelineActions';
import resizeFile from '../../utils/imageResizer';
import { map as asyncMap } from 'p-iteration';
import { toastr } from 'react-redux-toastr';
import formattedDate from '../../utils/formatDate';
import CompleteActionModal from '../../components/CompleteActionModal/CompleteActionModal';
import { EAccessRole } from '../../store/types';

const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  paper: {
    borderRadius: 7,
  },
  formTitle: {
    fontWeight: 600,
    paddingLeft: 5,
    paddingBottom: 10,
  },
  expandPanelStyle: {
    backgroundColor: '#eee',
    cursor: 'default',
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  opacityContainer: {
  },
  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    height: '140px',
  },
  infoContainer: {
    marginTop: 10,
    position: 'relative',
  },
  detailsContainer: {
    padding: '0px 20px 20px 20px',
  },
  label: {
    fontSize: 13,
  },
  labelEquipDetail: {
    marginLeft: 10
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
  serviceLabel: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  expandIcon: {
    '.MuiSvgIcon-root': {
      transform: 'rotate(180deg)'
    }
  },
  doneActionButton: {
    margin: 10,
    height: 40,
    backgroundColor: 'green',
  },
  cancelActionButton: {
    margin: 10,
    height: 40,
    backgroundColor: '#585858'
  },
  reopenActionButton: {
    margin: 10,
    height: 40,
    backgroundColor: 'green'
  },
  accountableChip: {
    margin: 0.5,
  },
  accountablesBox: {
    display: 'flex',
  }
}

const FormAction = (props) => {
  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);
  const [actionDetailsExpand, setActionDetailsExpand] = useState(false);
  const [completeModalIsOpen, setCompleteModalIsOpen] = useState(false);

  // parametros para busca do autocomplete
  const page =  1;
  const limit = 50;
  const orderBy = "name";
  const order = "asc";

  // forms do empresas
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [reporter, setReporter] = useState("");
  const [createdAt, setCreatedAt] = useState(new Date());
  const [deadline, setDeadline] = useState(new Date());
  const [maxDeadlineDate, setMaxDeadlineDate] = useState(new Date(2050, 11, 30));
  const [place, setPlace] = useState("");
  const [equipment, setEquipment] = useState("");
  const [reference, setReference] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [questionGroup, setQuestionGroup] = useState("");
  const [actionText, setActionText] = useState("");
  const [equipmentSN, setEquipmentSN] = useState("");
  const [equipmentDescription, setEquipmentDescription] = useState("");
  const [problemText, setProblemText] = useState("");

  // error forms
  const [nameError, setNameError] = useState(false);
  const [actionTextError, setActionTextError] = useState(false);
  const [problemTextError, setProblemTextError] = useState(false);

  const [accountableError, setAccountableError] = useState(false);
  const [uploadSubmitError, setUploadSubmitError] = useState(false)
  const [uploadEmptyFileError, setUuploadEmptyFileError] = useState(false)
  const [statusError, setStatusError] = useState(false)

  // selected values on autocomplete
  const [selectedAccountables, setSelectedAccountables] = useState([]);
  const [searchTextAccountable, setSearchTextAccountable] = useState("")
  const [accountablesFormated, setAccountablesFormated] = useState([])


  const [selectedStatus, setSelectedStatus] = useState([]);
  const [searchTextStatus, setSearchTextStatus] = useState("")
  const [statusFormated, setStatusFormated] = useState([])


  // fetch from BE
  const fetchActionService = useCallback(
    () => dispatch(actions.fetchActionsById(props.match.params.id))
  );

  const fetchAccountable = useCallback(
    () => dispatch(actions.fetchValidUsers(page, limit, searchTextAccountable, order, orderBy)),
    [page, limit, searchTextAccountable, order, orderBy]
  );

  // get from redux
  const userId = useSelector(state => state.auth.id);
  const role = useSelector(state => state.auth.selectedAccess.role);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const actionService = useSelector(state => state.actions.action);
  const users = useSelector(state => state.users.users);
  const accountables = actionService.accountables;
  const selectedAccountablesFormated = accountables?.map((accountable) => ({ label: accountable.name, value: accountable._id }));
  const maxAccountablesAllowed = useSelector(state => state.actions.maxAccountablesAllowed);

  const loadingActionService = useSelector(state => state.actions.loading);
  const loadingAccountable = useSelector(state => state.users.loading);

  const hasActionsDeadlineLimiter = useSelector(state => state.auth.selectedAccess.tenant?.hasActionsDeadlineLimiter);
  const actionsDeadlineLimit = useSelector(state => state.auth.selectedAccess.tenant?.actionsDeadlineLimit);

  const isContractor = role === EAccessRole.contractor;
  const isAnalyst = role === EAccessRole.analyst;
  const isAdmin = role === EAccessRole.admin;
  const hasCreatedAction = actionService?.createdBy === userId;
  const isAccountable = accountables?.some((accountable) => accountable._id === userId);
  const equipmentCompanyDiffsContractorCompany = actionService?.equipment?.companies?.every((companyId) => companyId !== selectedAccess?.company?._id);
  const canSeeEquipmentAndService = !(isContractor && equipmentCompanyDiffsContractorCompany);

  const canEditInfo = isAdmin || (isAnalyst && hasCreatedAction);
  const canAddFiles = isAdmin || isAnalyst || (isContractor && isAccountable);

  // FUNCTION TO FORMAT FIELD OF ACTIVITIES AND AREAS TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = users
    const returnArray = dataFromRedux.rows.map(dt => ({ value: dt._id, label: dt.name }))
    setAccountablesFormated(returnArray)
  }, [users])


  useEffect(() => {
    fetchAccountable(page, limit, searchTextAccountable, order, orderBy);
  }, [searchTextAccountable]);

  // check if is newEntrance or editing
  useEffect(() => {
    setStatusFormated([
      { value: 'progress', label: statusLabel('progress').title },
      { value: 'canceled', label: statusLabel('canceled').title },
      { value: 'completed', label: statusLabel('completed').title }
    ])

    setIsNewData(props.match.params.id === 'new')
    if (props.match.params.id !== 'new') {
      fetchActionService();
    }
  }, [])

  // in case editing, populate fields
  useEffect(() => {
    if (!isEmpty(actionService) && props.match.params.id !== 'new') {
      setReporter(actionService.service.inspectedBy.name)
      setCreatedAt(actionService.createdAt);
      setPlace(`${actionService.service.place.name} (${actionService.service.place.path})`);
      setReference(actionService.equipment.reference)
      setEquipment(actionService.equipment.equipmentModel.name)
      setServiceType(`${actionService.serviceInfo.serviceType} (${actionService.serviceInfo.frequency})`)
      setEquipmentSN(actionService.equipment.serialNumber)
      setEquipmentDescription(actionService.equipment.description)
      setQuestionText(actionService.questionText)
      setQuestionGroup(actionService.questionGroupName)
      setActionText(actionService.actionText)
      if (hasActionsDeadlineLimiter) {
        const firstDeadlineTime = new Date(actionService.firstDeadline).getTime();
        setMaxDeadlineDate(new Date(firstDeadlineTime + actionsDeadlineLimit * 24 * 60 * 60 * 1000));
      }
      if (accountables) {
        setSelectedAccountables(selectedAccountablesFormated)
      } else {
        setSelectedAccountables([])
      }
      if (actionService.problemText) setProblemText(actionService.problemText)
      else setProblemText('')
      setDeadline(actionService.deadline)
      setUploadedFiles(actionService.files)
      if (actionService.status === 'progress' && !(new Date() < moment(new Date(actionService.deadline)).endOf('day').toDate() || actionService.deadline === ''))
        setSelectedStatus({ value: 'progress', label: i18n.t('setSelectedStatusFormActions.label') });
      else
        setSelectedStatus({ value: actionService.status, label: statusLabel(actionService.status).title });
    }
  }, [actionService])

  // send data to Server (post and update)
  const updateActions = (body) => dispatch(actions.updateActions(props.match.params.id, body))
  const deleteActions = () => dispatch(actions.deleteActions(props.match.params.id));

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!actionText) {
      setActionTextError(true);
      hasError = true;
    }

    if (problemText === '' && canEditInfo) {
      setProblemTextError(true);
      hasError = true;
    }

    const notUploaded = uploadedFiles.filter(fl => fl.isNotUploaded)
    if (notUploaded.length > 0) {
      setUploadSubmitError(true)
      hasError = true;
    }

    const filesIds = []

    uploadedFiles.map(fl => {
      if (fl.id)
        return filesIds.push(fl.id)
      else if (fl._id)
        return filesIds.push(fl._id)
    });
    
    if(selectedAccountables?.length > maxAccountablesAllowed) {
      hasError = true;
      setAccountableError(true);
    }

    if (hasError) return

    const body = {
      status: selectedStatus.value,
      actionText,
      accountables: selectedAccountables?.map((accountable) => accountable.value) || [],
      deadline,
      files: filesIds,
      problemText,
    }
 
    updateActions(body).then(result => {
      if (result === 'success') {
        fetchActionService();
        setEditMode(false);
      }
    })
    
  }

  const handleSaveNewStatus = (status, files = [], message = '') => {
    const body = {
      status,
      message,
      files,
    }

    dispatch(actions.changeActionStatus(props.match.params.id, body));
  };

  const handleBack = () => {
    props.history.goBack()
  }

  const handleInputChangeSelectorAccountable = (text) => {
    setSearchTextAccountable(text);
  }

  const handleInputChangeAccountable = selected => {
    setAccountableError(false);
    setSelectedAccountables(selected)
  }

  const handleInputChangeSelectorStatus = (text) => {
    setSearchTextStatus(text);
  }

  const handleInputChangeStatus = selected => {
    setStatusError(false);
    setSelectedStatus(selected)
  }

  const handleDateChange = date => {
    setDeadline(date);
  }

  const handleUpload = async files => {
    const canUploadFiles = checkUploadPermissions();
    if (canUploadFiles) {
    const uploadingFiles = await asyncMap(files, async (file) => {
      const fileOptimized = await resizeFile(file)

      return ({
        file: fileOptimized,
        id: uniqueId(),
        name: fileOptimized.name,
        readableSize: filesize(fileOptimized.size),
        preview: URL.createObjectURL(fileOptimized),
        fileType: fileOptimized.type,
        progress: 0,
        isNotUploaded: true,
        error: false,
        url: null
      });
    });

    setUploadedFiles(prevUf => prevUf.concat(uploadingFiles))
    uploadingFiles.forEach(processUpload);
  } else {
    toastr.error('Erro', i18n.t('updateActionsStore.toastrError2'))
  }
  };

  const updateFile = (id, data) => {
    setUploadedFiles(prevUf => prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf))
  };


  const processUpload = async uploadedFile => {

    API.post("files/signurl", { file: uploadedFile }).then(signUrlRes => {

      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile.id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `files/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("files", body)
          .then(response => {
            setUploadSubmitError(false)
            updateFile(uploadedFile.id, {
              isNotUploaded: false,
              id: response.data._id,
              url: response.data.url,
              error: false,
              loading: false,
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true,
              loading: false,
            });
          });
      })
    })
  }

  const checkPermission = (id) => {
    const file = uploadedFiles.find(fl => fl.id === id)
    if (isContractor) {
      if (typeof file.uploaded !== 'undefined' && (canSeeEquipmentAndService || isAccountable)) {
        handleDeleteFile(id, true);
      } else {
        toastr.error('Erro', i18n.t('updateActionsStore.toastrError2'));
      }
    } else {
      handleDeleteFile(id, false);
    }
  }

  const checkUploadPermissions = () => {
    if (isContractor) {
      if (canSeeEquipmentAndService || isAccountable) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  const handleDeleteFile = async (id, isContractor) => {
    try {
      if (!isContractor) await API.delete(`files/${id}`)
      setUploadedFiles(prevUf => prevUf.filter(file => file.id !== id && file._id !== id))

    } catch (e) {
      console.log('e', e);
    }
  }

  const handleDeleteDocumentFile = (id) => {
    if (!editMode && !isNewData && !completeModalIsOpen) return;
    confirm(i18n.t('handleDeleteDocumentFileFormActions.confirm'),
      {
        title: i18n.t('handleDeleteDocumentFileFormActions.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          checkPermission(id)
        },
      )
  }

  const handleCancelAction = () => {
    confirm(i18n.t('handleCancelActionFormActions.confirm'),
      {
        title: i18n.t('handleCancelActionFormActions.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          handleSaveNewStatus('canceled');
        },
      );
  };

  const handleOpenCompleteModal = () => {
    setEditMode(false);
    setCompleteModalIsOpen(true);
  }

  const handleCloseCompleteModal = () => {
    dispatch(actions.clearCompleteActionFiles());
    setCompleteModalIsOpen(false);
  }

  const handleCompleteAction = (files, message) => {
    handleSaveNewStatus('completed', files, message);
  };

  const handleReopenAction = () => {
    confirm(i18n.t('handleReopenActionFormActions.confirm'),
      {
        title: i18n.t('handleReopenActionFormActions.title'),
        titleColor: 'green',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          handleSaveNewStatus('progress');
        },
      );
  };

  const handleDelete = () => {
    confirm(i18n.t('handleDeleteFormActions.confirm'),
      {
        title: i18n.t('handleDeleteFormActions.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteActions().then(() => {
            setEditMode(false);
            props.history.goBack();
          });
        },
      );
  };

  const goToService = (id) => {
    props.history.push(`/form-edit-service/${id}`);
  }

  const goToEquipment = (id) => {
    props.history.push(`/form-equip/${id}/form-action/${props.match.params.id}`);
  };

  const handleClose = () => {
    setEditMode(false);
    setReporter(actionService.service.inspectedBy.name)
    setCreatedAt(actionService.createdAt);
    setPlace(`${actionService.service.place.name} (${actionService.service.place.path})`);
    setEquipment(actionService.equipment.equipmentModel.name)
    setReference(actionService.equipment.reference)
    setServiceType(`${actionService.serviceInfo.serviceType} (${actionService.serviceInfo.frequency})`)
    setEquipmentSN(actionService.equipment.serialNumber)
    setEquipmentDescription(actionService.equipment.description)
    setQuestionText(actionService.question.name)
    setQuestionGroup(actionService.questionGroupName)
    setActionText(actionService.actionText)
    if (accountables?.length > 0) {
      setSelectedAccountables(selectedAccountablesFormated)
    } else {
      setSelectedAccountables([])
    }
    if (actionService.problemText) setProblemText(actionService.problemText)
    else setProblemText('')
    setDeadline(actionService.deadline)
    setUploadedFiles(actionService.files)
    if (actionService.status === 'progress' && !(new Date() < moment(new Date(actionService.deadline)).endOf('day').toDate() || actionService.deadline === ''))
      setSelectedStatus({ value: 'progress', label: i18n.t('setSelectedStatusFormActions.label') });
    else
      setSelectedStatus({ value: actionService.status, label: statusLabel(actionService.status).title });
  };

  return <>
    {completeModalIsOpen && (
      <CompleteActionModal
        closeModal={handleCloseCompleteModal}
        handleCompleteAction={handleCompleteAction}
      />
    )}
    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <div style={matches ? styles.divContainer : styles.divContainerSmall}>
      <Container maxWidth='md' style={styles.container}>
        {loadingActionService && <Spinner overlay />}
        <Typography variant='h6' style={styles.formTitle}>{props.match.params.id === 'new' ? i18n.t('typographyFormActions.true') : i18n.t('typographyFormActions.false')}</Typography>
        <ButtonGroup>
          {!isNewData && selectedStatus.value && selectedStatus.value !== 'completed' && selectedStatus.value !== 'canceled' &&
            <Button variant="contained" onClick={handleCancelAction} color="secondary" style={styles.cancelActionButton} disabled={!canAddFiles}>
              {i18n.t('buttonFormActions.cancel')}
            </Button>}
          {!isNewData && selectedStatus.value && (selectedStatus.value === 'canceled' || selectedStatus.value === 'completed') &&
            <Button variant="contained" onClick={handleReopenAction} color="primary" style={styles.reopenActionButton} disabled={!canAddFiles}>
              {i18n.t('buttonFormActions.reopen')}
            </Button>}
          {!isNewData && selectedStatus.value && selectedStatus.value && selectedStatus.value !== 'completed' && selectedStatus.value !== 'canceled' &&
            <Button variant="contained" onClick={handleOpenCompleteModal} color="primary" style={styles.doneActionButton} disabled={!canAddFiles}>
              {i18n.t('buttonFormActions.done')}
            </Button>}
        </ButtonGroup>
        <Paper style={styles.paper}>
          <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingActionService ? '0.3' : '1' }}>
            <DivFormTitle>
              {selectedStatus.value &&
                <FormStatus style={{ borderColor: statusLabel(selectedStatus.value, deadline).color }}>
                  <FormStatusLabel>{i18n.t('formStatusLabelFormActions.label')}</FormStatusLabel>
                  <FormStatusValue>{selectedStatus.label}</FormStatusValue>
                </FormStatus>}
              {!isNewData &&
                <DivSubmitButtons>
                  {editMode ?
                    <>
                      <IconButton onClick={() => handleClose()} size="large"><CloseIcon color='error' /></IconButton>
                      <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                    </> :
                    <>
                      <IconButton onClick={() => setEditMode(true)} size="large" disabled={!canAddFiles}>
                        <Tooltip title={i18n.t('tooltipFormActions.edit')}><EditIcon /></Tooltip>
                      </IconButton>
                      <IconButton onClick={() => handleDelete()} size="large" disabled={!canEditInfo}>
                        <Tooltip title={i18n.t('tooltipFormActions.delete')}><DeleteIcon /></Tooltip>
                      </IconButton>
                    </>}
                </DivSubmitButtons>}
            </DivFormTitle>
            <>
              <div style={styles.infoContainer}>
                <ExpandPainelContainer>
                  <Accordion expanded={actionDetailsExpand} styles={styles.expandPanelStyle}>
                    <AccordionSummary
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <ExpandPainelItemContainer>
                        <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.local')}
                        </ExpandPainelItemLabel>
                        {place}
                      </ExpandPainelItemContainer>
                      <ExpandPainelItemContainer>
                        <ExpandPainelItemLabel>
                        {i18n.t('expandPainelItemLabelformActions.equipment')}
                           {(!isNewData && canSeeEquipmentAndService) &&
                            <IconButton
                              style={{ marginLeft: 5, cursor: 'pointer', background: '#cdd8ea', padding: '0px 2px 0px 2px', borderRadius: 3 }}
                              onClick={() => goToEquipment(actionService.equipment._id)}
                              size="large">
                              <Tooltip title={i18n.t('tooltipFormActions.equipment')}>
                                <LinkIcon color='primary' />
                              </Tooltip>
                            </IconButton>}
                        </ExpandPainelItemLabel>
                        {equipment}
                      </ExpandPainelItemContainer>
                      <ExpandPainelItemContainer>
                        <ExpandPainelItemLabel>
                        {i18n.t('expandPainelItemLabelformActions.service')}
                          {(!isNewData && canSeeEquipmentAndService) &&
                            <IconButton
                              style={{ marginLeft: 5, cursor: 'pointer', background: '#cdd8ea', padding: '0px 2px 0px 2px', borderRadius: 3 }}
                              onClick={() => goToService(actionService.service._id)}
                              size="large">
                              <Tooltip title={i18n.t('tooltipFormActions.service')}>
                                <LinkIcon color='primary' />
                              </Tooltip>
                            </IconButton>}
                        </ExpandPainelItemLabel>
                        {serviceType}
                      </ExpandPainelItemContainer>
                      <ExpandPainelItemContainer>
                        <ExpandPainelItemLabel>
                        {i18n.t('expandPainelItemLabelformActions.questionGroup')}
                        </ExpandPainelItemLabel>
                        <Typography>{questionGroup}</Typography>
                        <ExpandPainelItemLabel>
                        {i18n.t('expandPainelItemLabelformActions.questionText')}
                        </ExpandPainelItemLabel>
                        <Typography>{questionText}</Typography>                        
                      </ExpandPainelItemContainer>
                      <ExpandPainelButton onClick={() => setActionDetailsExpand(true)}>
                        {!actionDetailsExpand && <ExpandMoreIcon />}
                        {!actionDetailsExpand && i18n.t('expandPainelButtonFormActions.more')}
                      </ExpandPainelButton>
                    </AccordionSummary>
                    {actionDetailsExpand &&
                      <AccordionDetails>
                        <ExpandPainelItemContainer>
                          <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.actionBy')}
                          </ExpandPainelItemLabel>
                          {`${reporter} em ${moment(createdAt).format('DD/MM/YYYY')}`}
                        </ExpandPainelItemContainer>
                        <ExpandPainelItemContainer>
                          <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.sn')}
                          </ExpandPainelItemLabel>
                          {equipmentSN || i18n.t('expandPainelItemLabelformActions.text')}
                        </ExpandPainelItemContainer>
                        <ExpandPainelItemContainer>
                          <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.description')}
                          </ExpandPainelItemLabel>
                          {equipmentDescription}
                        </ExpandPainelItemContainer>
                        <ExpandPainelItemContainer>
                          <ExpandPainelItemLabel>
                            {i18n.t('expandPainelItemLabelformActions.equipmentReference')}
                              </ExpandPainelItemLabel>
                          {reference}
                        </ExpandPainelItemContainer>
                        <ExpandPainelButton active={actionDetailsExpand} onClick={() => setActionDetailsExpand(false)}>
                          {actionDetailsExpand && <ExpandMoreIcon styles={styles.expandIcon} />}
                          {actionDetailsExpand && i18n.t('expandPainelButtonFormActions.less')}
                        </ExpandPainelButton>
                      </AccordionDetails>}
                  </Accordion>
                </ExpandPainelContainer>
              </div>
              <div style={styles.detailsContainer}>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    label={'ID'}
                    name='ActionId'
                    disabled={true}
                    InputProps={{
                      readOnly: !isNewData && !editMode,
                    }}
                    value={(props.match.params.id).slice(-6).toUpperCase()}
                    margin='normal' />
                </FormControl>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    InputProps={{
                      readOnly: !editMode,
                    }}
                    label={i18n.t('textFieldFormActions.problemText')}
                    name='problemText'
                    onChange={event => {setProblemTextError(false); setProblemText(event.target.value);}}
                    value={problemText}
                    disabled={editMode && !canEditInfo}
                    error={problemTextError}
                    margin='normal' />
                </FormControl>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    InputProps={{
                      readOnly: !editMode,
                    }}
                    label={i18n.t('textFieldFormActions.actionText')}
                    name='actionText'
                    onChange={event => {setActionTextError(false); setActionText(event.target.value.toUpperCase())}}
                    value={actionText}
                    disabled={editMode && !canEditInfo}
                    error={actionTextError}
                    margin='normal' />
                </FormControl>
                {!isNewData && !isContractor &&
                  <FormControl variant="standard" fullWidth margin='normal'>
                    <Autocomplete
                      loading={loadingAccountable} // sent to isLoading
                      label={i18n.t('autocompleteFormActions.accountable')}
                      data={accountablesFormated} // sent to options
                      onSelectValue={handleInputChangeAccountable} // sent to onChange
                      valueSelected={selectedAccountables} // sent to value
                      newSearchText={handleInputChangeSelectorAccountable}
                      name='funcao'
                      hasError={accountableError}
                      InputProps={{
                        readOnly: !editMode,
                      }}
                      isMulti
                      disabled={(editMode && !canEditInfo) || !editMode}
                    />
                    {accountableError && <FormHelperText sx={{color: '#d32f2f'}}>{`${i18n.t('autocompleteFormActions.helperText')} ${maxAccountablesAllowed}`}</FormHelperText>}
                  </FormControl>
                }
                {isContractor && !isNewData && <Box>
                  <Typography variant='subtitle2' sx={{opacity: 0.6, fontWeight: 400, lineHeight: '1.4375em'}}>{i18n.t('autocompleteFormActions.accountable')}</Typography>
                  {selectedAccountables.map((accountable) => <Chip
                    key={accountable.value}
                    label={accountable.label}
                    sx={{ marginTop: '5px', cursor:'default', marginLeft: '5px'}}/>
                  )}
                </Box>
              }
                {!isNewData && editMode ?
                  <DatePicker
                  required
                  label={i18n.t('keyboardDatePickerFormActions.deadline')}
                  margin='normal'
                  value={new Date(deadline)}
                  maxDate={maxDeadlineDate}
                  InputProps={{
                    readOnly: !editMode,
                  }}
                  // error={editMode}
                  onChange={date => handleDateChange(date)}
                  // minDate={new Date()}
                  format="dd/MM/yyyy"
                  disabled={editMode && !canEditInfo}
                  slotProps={{ textField: { variant: 'standard', } }}
                  sx={{marginTop: '16px', marginBottom: '8px'}}
                /> :
                  <>
                    {actionService.deadline && 
                      <FormControl variant="standard" fullWidth>
                        <TextField
                          variant="standard"
                          multiline
                          InputProps={{
                            readOnly: !isNewData && !editMode,
                          }}
                          label={i18n.t('keyboardDatePickerFormActions.deadline')}
                          name='deadline'
                          value={formattedDate(actionService.deadline)}
                          margin='normal' />
                      </FormControl>
                    }
                  </>
                }
                <div style={styles.sectionTitleContainer}>
                  <AttachIcon style={{ color: (!editMode || !canAddFiles) ? 'lightgrey' : '#000' }} />
                  <Typography style={{ color: (!editMode || !canAddFiles) ? 'lightgrey' : '#000' }}>{i18n.t('typographyFormActions.file')}</Typography>
                </div>
                <Upload onUpload={handleUpload} disabled={!editMode || !canAddFiles} />
                {!!uploadedFiles.length && (
                  <FileList files={uploadedFiles} onDelete={handleDeleteDocumentFile} disabled={!editMode || !canAddFiles} />
                )}
                {uploadSubmitError && <div style={styles.fileError}>{i18n.t('divFormActions.fileError')}</div>}
              </div>
            </>
            {isNewData &&
              <DivSubmitButtons>
                <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
              </DivSubmitButtons>}
          </FormStyled>
        </Paper>
      </Container>
      {props.match.params.id !== 'new' && <TimelineActions disabled={!canAddFiles} />}
    </div>
  </>;
}

export default FormAction;
